import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { PeopleProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const QUERY = graphql`
query NodeAllPeopleQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "People" } }) {
    nodes {
      data
    }
  }
}
`;

export const PeopleProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(QUERY), 'items')}>{children}</Provider>;
};
